module.exports = __webpack_public_path__ + "5d588b04.svg";